export const HEADER_IDS = {
  POINTS: 'points',
  PURCHASE_AMOUNT: 'purchaseAmount',
};
